import React, { Component } from 'react';
import './PaymentChooser.scss';
import languageService from '../../services/languageService';
import paymentTypeService from '../../services/paymentTypeService';
import Slider from 'react-slick';
import paymentService from '../../services/paymentService';

const paymentTypes = paymentTypeService.getPaymentTypes();

class PaymentChooser extends Component {
    constructor(props) {
        super(props);
        this.onPaymentMeanChange = props.onPaymentMeanChange instanceof Function ? props.onPaymentMeanChange : () => {
        };
        this.excludes = props.excludes ? props.excludes : [];
        this.paymentTypes = paymentTypes.filter(el => !this.excludes.includes(el.type));
        this.state = {
            selectedValue: null
        };
    }

    onChange = event => {
        const selectedValue = document.getElementById('alternative-payment-method').value;

        this.setState({
            selectedValue: selectedValue || null
        });
    };

    onClick = event => {
        this.onPaymentMeanChange(this.state.selectedValue);
    };

    getSlickSettings = () => {
        const { paymentTypes } = this;

        let slideToShow = 6;
        if (paymentTypes.length < 6) {
            slideToShow = paymentTypes.length;
        }

        return {
            dots: false,
            infinite: paymentTypes.length > 1,
            speed: 500,
            slidesToScroll: 1,
            slidesToShow: slideToShow,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        };
    };

    render() {
        const { paymentTypes } = this;

        return (
            <div className="input-group">
                <div className="PaymentChooser">
                    <h3 className="title">{languageService.texts.orChoseAlternative}</h3>
                    <div className="payment-inputs">
                        <Slider {...this.getSlickSettings()}>
                            {paymentTypes.map(payment => {
                                return (
                                    <div className="payment-input" key={payment.type}>
                                        <div className="payment-container">
                                            <button className="payment-button" onClick={() => {
                                                paymentService.forwardToExternal(payment.apiType);
                                            }}>
                                                <img alt={payment.name}
                                                     src={'./Templates/imagesPaymentPageDropDown_v1_PaymentPage/images/' + payment.logo}/>
                                            </button>
                                            <span className="input-label">{payment.name}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                    <div className="matrix-container">
                        <ul className="matrix">
                            {paymentTypes.map(payment => {
                                return (
                                    <li className="matrix-item" key={payment.type}>
                                        <div className="payment-method">
                                            <button className="payment-method-button" onClick={() => {
                                                paymentService.forwardToExternal(payment.apiType);
                                            }}>
                                                <img className="payment-method-image" alt={payment.name}
                                                     src={'./Templates/imagesPaymentPageDropDown_v1_PaymentPage/images/' + payment.logo}/>
                                            </button>
                                            <span className="payment-method-label">{payment.name}</span>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentChooser;



// WEBPACK FOOTER //
// ./src/components/PaymentChooser/PaymentChooser.js